import React from 'react';
import { Icon } from '@americanexpress/dls-react';

const IconClass = () => (
  <Icon
    size="md"
    theme={{
      color: '#006FCF !important',
      fill: '#006FCF !important',
    }}
  >
    <svg
      style={{ margin: '14px' }}
      height="1em"
      viewBox="0 0 48 48"
      width="1em"
      role="img"
      aria-label="info"
    >
      <path d="M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 3C12.421 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm0 16a1.5 1.5 0 011.5 1.5V33h2a1.5 1.5 0 110 3h-7a1.5 1.5 0 110-3h2V22H21a1.5 1.5 0 110-3h3zm-.5-7a2 2 0 110 4 2 2 0 010-4z" />
    </svg>
  </Icon>
);

export default IconClass;
